import React, { Component } from 'react';
import { SingleDatePicker } from 'react-dates';
import { Table, Form, Segment, Button, Divider, } from 'semantic-ui-react';
import Select from 'react-select';
import FileUploader from 'react-firebase-file-uploader';
import { checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import axios from 'axios'
import { firebaseAuth, toCurrency, pythonApiIp, firebaseStorage, logComponentLoad, serverIp } from '../../../../config/constants.js'
//import PaySingleStockItem from '../StockPayment/PaySingleStockItem'
import ViewStockPaymentSummary from '../StockPayment/ViewStockPaymentSummary'

//import { getShirtTypeDownDown } from '../dashBoard/newDashboard/LargeProjects/ApiUtils'
import { getShirtTypesToDisplay } from '../LargeProjects/ApiUtils'
import * as UiConsts from '../../../../config/UiConstants';
import DeductExpenseAccount from '../ExpenseAccounts/DeductExpenseAccount';
//import PayTodaysItems from './PayTodaysItems';
import { getPrintValues } from '../../newDashboard/algoliaDashboard/AlgoliaMiscUtils';



class DailyExpenses_ivan extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dailyExpenseOptions: [],
            dailyExpense: '',
            newDailyExpense: '',
            newDailyExpense: '',
            itemArray: [],
            shirtTypeOptions: [],
            dateNum: '',
            qty: '',
            price: '',
            notes: '',
            loading: false,
            deduct_awori_log: "no",
            deduct_awori_log_choices: [
                { value: 'yes', label: 'yes', category: 'deduct_awori_log' },
                { value: 'no', label: 'no', category: 'deduct_awori_log' },
            ],

            fromWhere: '',
            fromWhereOptions:[],
            // fromWhereOptions: [
            //     {
            //         "category": "fromWhere",
            //         "label": "largeProject",
            //         "value": "largeProject",
            //         "key": "largeProject"
            //     },
            //     {
            //         "category": "fromWhere",
            //         "label": "normalOrders",
            //         "value": "normalOrders",
            //         "key": "normalOrders"
            //     },
            //     {
            //         "category": "fromWhere",
            //         "label": "stockPayment",
            //         "value": "stockPayment",
            //         "key": "stockPayment"
            //     },
            //     {
            //         "category": "fromWhere",
            //         "label": "bidding",
            //         "value": "bidding",
            //         "key": "bidding"
            //     },
            // ]
        }
    }

    componentDidMount() {
        //1. GET MAIN CARD OBJECTS FROM ALGOLIA
        //getPrintValues("dailyExpenses", this.setDailyExpenseOptions);

        //console.log(`user's device is: ${window.navigator.userAgent}`);

        getShirtTypesToDisplay(this.setShirtTypeDropDown, "dailyExpense_ivan");
        
        //getShirtTypesToDisplay(this.setFromWhere, "fromWhere");

        getPrintValues("fromWhere", this.loadStatuses);

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("elx1 +++++++++:removeListener");

            if (user) {
                console.log("maddx241 user is:" + user.email);

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })
            }
        })
    }

    loadStatuses = (statuses) => {
        //  console.log("ddx12 ++++++ loadStatuses ");
        // console.log("ddx121 statuses:" + JSON.stringify(statuses, null, 3));
        this.setState({ fromWhereOptions: statuses })
    }

    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
        //console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        logComponentLoad(returnObject, "DailyExpenses_ivan");
        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })
    }

    setShirtTypeDropDown = (shirtTypes) => {
        console.log("gshtx21 +++++++:setShirtTypeDropDown");
        // console.log("gshtx22:" + JSON.stringify(shirtTypes, null, 3));
        this.setState({
            dailyExpenseOptions: shirtTypes
        })

    }

    setFromWhere = (shirtTypes) => {
        console.log("gshtx21 +++++++:setShirtTypeDropDown");
        // console.log("gshtx22:" + JSON.stringify(shirtTypes, null, 3));
        this.setState({
            fromWhereOptions: shirtTypes
        })

    }

    setDailyExpenseOptions = (objects) => {
        console.log("obx1 +++++++:setDailyExpenseOptions");
        // console.log("obx12 hits:"+JSON.stringify(objects, null, 3));
        this.setState({
            dailyExpenseOptions: objects
        })

    }

    handleDropDownChanges = (value) => {
        console.log("handleDropDownChanges");
        console.log('cv32 You\'ve sss:', value);
        console.log('cv32 You\'ve selected:', value.value + " " + value.category);

        this.setState({
            dailyExpense: value.value,
            newDailyExpense: value.label,
        });
    }

    handleOrderDetailsDropDownChanges = (value) => {
        console.log('fdbx1 You\'ve sss:', value);
        console.log('fdbx12 You\'ve selected:', value.value + " " + value.category);

        let newState = {};
        newState[value.category] = value.value;

        this.setState(newState);
    }

    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    dateSelectOnChange = (date) => {
        console.log("++++++++:dateSelectOnChange");
        console.log("date:" + date);
        console.log("date.getValue():" + date.valueOf());
        this.setState({
            date: date,
            dateNum: date.valueOf(),
            dateString: date.format('dddd MMMM Do')

        })
    }


    sendList = () => {
        console.log("++++++++:sendList");
        console.log("date:" + this.state.dateNum);

        this.setState({ loading: true });

        //axios.post(pythonApiIp + 'addExpense', {
        axios.post(serverIp + 'billing/dailyExpense_ivan', {
            apiKey: "daily_expense_ivan",
            item: this.state.newDailyExpense,
            qty: this.state.qty,
            price: this.state.price,
            notes: this.state.notes,
            imageUrl: this.state.docUrl,
            enteredBy: this.state.user.email,
            dateSent: this.state.dateNum,
            deduct_awori_log: this.state.deduct_awori_log,
            fromWhere: this.state.fromWhere
        })
            .then((response) => {
                console.log(response.data);
                this.setState({ loading: false });
                // console.log("entx22 result:" + response.data.result);

                if (response.data.result) {

                    alert("expenses sent.");
                    this.setState({
                        item: '',
                        qty: '',
                        price: '',
                        notes: '',
                        docUrl: null,
                        itemArray: []
                    })

                } else {

                    this.setState({ loading: false });

                    alert(response.data.message);

                }
                //this.resetFields();
            })
            .catch((error) => {
                console.log(error);
                this.setState({ loading: false })
            });

    }

    /**
    * HANDLE THE FILE UPLOADING..
    */
    handleUploadStart = (file) => {
        console.log("docx14 ++++++ handle uploadStart file:" + file.name.split('.')[0]);

        this.setState({ isUploading: true, progress: 0, actualFileName: file.name });
    }

    // handleUploadSuccess = (fileName) => this.setState({fileName:fileName, isUploading: false, progress: 100});
    handleUploadSuccess = (saveFileName) => {
        console.log("docx15 +++++++handleUploadSuccess");

        this.setState({ fileName: saveFileName, isUploading: false, progress: 100 });

        //UDPATE URL 
        // let orderKey = this.props.fileName;
        firebaseStorage.ref('printbdocs').child(saveFileName).getDownloadURL().then(
            url => {
                this.setState({ docUrl: url })
                console.log("docx16 docUrl is:" + url);

                // let tempRef = db.ref('orders').child(orderKey);
                // //UDPATE FIREBASE OBJECT WITH OBJECT NAME..
                // tempRef.update('fileUrl':url);

                // let updates = {};
                // updates['/orders/' + orderKey + '/fileUrl'] = url;
                // updates['/orders/' + orderKey + '/fileName'] = saveFileName;
                // updates['/orders/' + orderKey + '/usersFileName'] = this.state.actualFileName;
                // ref.update(updates);
                this.updateWhenFileUploadComplete(true, this.state.actualFileName, url);
            }
        );
    };

    //  firebase.storage().ref('images').child(filename).getDownloadURL().then(url => this.setState({avatarURL: url}));
    handleProgress = (progress) => this.setState({ progress });
    handleUploadError = (error) => {
        console.log("docx16 +++++++: handleUploadError");

        this.setState({ isUploading: false });
        console.error(error);
    }

    updateWhenFileUploadComplete = (uploaded, fileName, url) => {
        console.log("docx17 +++++++: updateWhenFileUploadComplete");
        console.log("docx181 uploaded:" + uploaded);
        console.log("docx18 fileName:" + fileName);
        console.log("docx19 url:" + url)
    }

    render() {

        const sendButtonUI = this.state.dateNum != ''
            && this.state.dailyExpense != ''
            && this.state.qty != ''
            && this.state.price != ''
            && this.state.notes != ''
            && this.state.newDailyExpense != ''
            && this.state.fromWhere != ''
            ? <Button color='green'> SEND EXPENSE </Button>
            : ''

        const userEmail = this.state.user && this.state.user.email
            ? <h3>{this.state.user.email}</h3>
            : 'no email'

        const fileUploadUI = <div>
            <h4>DOCLINK: {this.state.docUrl}</h4>
            <FileUploader
                accept="*,"
                name="avatar"
                filename={this.props.fileName}
                //storageRef={firebaseStorage.ref('orderDesigns/')}
                storageRef={firebaseStorage.ref('printbdocs')}
                onUploadStart={this.handleUploadStart}
                onUploadSuccess={this.handleUploadSuccess}
                onProgress={this.handleProgress}
            />
        </div>

        // const paySingleStockItem = this.state.user && this.state.user.email
        //     ? <PaySingleStockItem user={this.state.user} />
        //     : ''

        const viewStockPaymentSummaryUi = this.state.user && this.state.user.email
            ? <ViewStockPaymentSummary user={this.state.user} />
            : ''

        const deductExpenseAccountUI = this.state.user && this.state.user.email
            ? <DeductExpenseAccount user={this.state.user} />
            : ''

        // const payTodaysItems = this.state.user && this.state.user.email
        //     ? <PayTodaysItems user={this.state.user} />
        //     : ''


        const wholeUI = this.state.algoliaUser
            && this.state.algoliaUser != ''
            && this.state.algoliaUser.perms
            && this.state.algoliaUser.perms.includes("DailyExpenses_ivan")
            ? <div>

                <Segment>
                    <Form fixed onSubmit={this.sendList}>
                        <SingleDatePicker
                            date={this.state.date} // momentPropTypes.momentObj or null
                            //onDateChange={date => this.setState({ date })} // PropTypes.func.isRequired
                            onDateChange={date => this.dateSelectOnChange(date)} // PropTypes.func.isRequired
                            focused={this.state.focused} // PropTypes.bool
                            isOutsideRange={() => false}
                            onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                        />
                        <h2>{this.state.dateString}</h2>
                        {/* <label>{this.state.dailyExpense} </label> */}
                        <label>SELECT THE COST </label>
                        <label>{this.state.newDailyExpense} </label>
                        <Select
                            name="form-field-name"
                            value={this.state.dailyExpense}
                            options={this.state.dailyExpenseOptions}
                            onChange={this.handleDropDownChanges}
                            searchable={true}
                            clearable={false}
                        />

                        <label> FROM WHERE </label>
                        <Select
                            name="form-field-name"
                            value={this.state.fromWhere}
                            options={this.state.fromWhereOptions}
                            onChange={this.handleOrderDetailsDropDownChanges}
                            searchable={false}
                            clearable={false}
                        />


                        <label>Deduct Awori Log?</label>
                        <Select
                            name="form-field-name"
                            value={this.state.deduct_awori_log}
                            options={this.state.deduct_awori_log_choices}
                            onChange={this.handleOrderDetailsDropDownChanges}
                            searchable={false}
                            clearable={false}
                        />

                        {/* QTY */}
                        <Form.Field>
                            <label>Qty: {this.state.qty} </label>
                            <Form.Input
                                fluid
                                name={'qty'}
                                value={this.state.qty}
                                icon='add user'
                                iconPosition='left'
                                placeholder='Qty'
                                onChange={this.handleTextInputChange}
                                type='number'
                            />
                        </Form.Field>

                        {/* PRICE */}
                        <Form.Field>
                            <label>Price: {toCurrency(this.state.price)} </label>
                            <Form.Input
                                fluid
                                name={'price'}
                                value={this.state.price}
                                icon='add user'
                                iconPosition='left'
                                placeholder='Price'
                                onChange={this.handleTextInputChange}
                                type='number'
                            />
                        </Form.Field>

                        {/* NOTES */}
                        <Form.Field>
                            <label>Notes: {this.state.notes} </label>
                            <Form.Input
                                fluid
                                name={'notes'}
                                value={this.state.notes}
                                icon='add user'
                                iconPosition='left'
                                placeholder='Notes'
                                onChange={this.handleTextInputChange}
                                type='text'
                            />
                        </Form.Field>

                        <Divider horizontal>{'DOC UPLOAD'}</Divider>
                        {fileUploadUI}

                        {sendButtonUI}

                    </Form>
                </Segment>

                <br />
                {/* {paySingleStockItem} */}

                <br />
                {/* {payTodaysItems} */}

                {/* <br />
                {viewStockPaymentSummaryUi} */}

                <br />
                {/* {deductExpenseAccountUI} */}

            </div>
            : <div><h2>YOU ARE NOT AN AUTHORIZED</h2>{userEmail}</div>

        return (this.state.loading ? <UiConsts.LoadingComponent /> : <div>
            <h1>Enter Expenses</h1>
            {wholeUI}

        </div>);
    }
}

export default DailyExpenses_ivan;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Billing/DailyExpenses_ivan.js